import { BugFilled } from '@ant-design/icons';
import { Alert, Button, Card, Flex, Row } from 'antd';
import backgroundImage from '../Assets/Images/Babes.png';
import { t } from 'i18next';

export const ErrorPage = () => {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <Flex
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <Card
        style={{
          display: 'block',
        }}
      >
        <Row style={{ margin: 10 }}>
          <Alert
            message={t('errorPage.message')}
            description={t('errorPage.description')}
            type="error"
            showIcon
            icon={<BugFilled />}
          ></Alert>
        </Row>
        <Row gutter={[16, 0]} style={{ marginLeft: 10, marginTop: 40 }}>
          <Button type="primary" onClick={handleReload}>
            Try again
          </Button>
        </Row>
      </Card>
    </Flex>
  );
};
